import "./RouteLoadingFallback.css";

/**
 * Loader for React Suspense while lazy route chunks load.
 * Shows a minimal animated loading bar.
 */
export const RouteLoadingFallback = () => (
  <div
    className="route-loading-fallback"
    role="status"
    aria-live="polite"
    aria-label="Loading page"
  >
    <div className="route-loading-inner">
      <div className="route-loading-rule" aria-hidden>
        <div className="route-loading-rule-highlight" />
      </div>
    </div>
  </div>
);
